@if (resumen; as r) {
  <section class="em-info">
    <!-- Resumen: los tiempos. El estado, el código y la situación están en
         el encabezado. -->
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Tiempo de respuesta" [valor]="r.respuesta" />
        <app-dt-dato [etiqueta]="r.tituloTotal" [valor]="r.total" />
        <app-dt-dato etiqueta="Reasignaciones" [valor]="r.reasignaciones" />
      </app-dt-datos>
    </app-dt-card>

    <div class="em-grilla" [class.sin-mapa]="!mapCardConfig">
      <div class="em-columna">
        @for (t of tarjetas; track t.titulo) {
          <ng-container
            *ngTemplateOutlet="tarjeta; context: { $implicit: t }"
          ></ng-container>
        }
      </div>

      @if (mapCardConfig) {
        <!-- Llena el alto de la columna de las tarjetas (altoMapa) -->
        <div class="em-mapa" #contenedorMapa>
          <app-map-card
            [config]="mapCardConfig"
            [mapOptions]="mapOptions"
            [height]="
              pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '420px'
            "
          ></app-map-card>
        </div>
      }
    </div>

    <div class="em-anchas">
      @for (t of tarjetasAnchas; track t.titulo) {
        <ng-container
          *ngTemplateOutlet="tarjeta; context: { $implicit: t }"
        ></ng-container>
      }
    </div>
  </section>
}

<ng-template #tarjeta let-t>
  <app-dt-card [titulo]="t.titulo" [icono]="t.icono">
    <app-dt-datos>
      @for (f of t.filas; track f.etiqueta) {
        @if (f.badges?.length) {
          <app-dt-dato [etiqueta]="f.etiqueta" ocultarVacio>
            <span class="em-badges">
              @for (b of f.badges; track $index) {
                <span class="em-badge" [style.--tono]="b.color">
                  <mat-icon>{{ b.icono }}</mat-icon>
                  {{ b.label }}
                </span>
              }
            </span>
          </app-dt-dato>
        } @else if (f.ruta && f.valor) {
          <app-dt-dato [etiqueta]="f.etiqueta" [valor]="f.valor">
            <a
              irxBotonIcono
              tamano="mini"
              [routerLink]="f.ruta"
              tooltip="Ver detalle"
            >
              <mat-icon>visibility</mat-icon>
            </a>
          </app-dt-dato>
        } @else {
          <app-dt-dato [etiqueta]="f.etiqueta" [valor]="f.valor" />
        }
      }
    </app-dt-datos>
  </app-dt-card>
</ng-template>
